import React, {useContext} from "react";
import { Route, Redirect } from "react-router-dom";
import {MainContext} from '../App';


// se não tem usuário preenchido, redireciona para logon...
function PrivateRoute({ render, ...rest }) {
  const { user } = useContext(MainContext)

  return (
    <Route {...rest}
      render={() => Boolean(user) ? render() : (
        <Redirect to="/logon" />
      )}
    />
  );
}

export default PrivateRoute;
